import React, { useEffect, useRef, useState, useContext } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import PageLeaveWrapper from "../../Utils/PageLeaveWrapper";
import { Alert, Button, Dialog, Grid, Snackbar, Switch } from "@mui/material";
import ImageViewer from "../../Component/ImageViewer";
import BlankTable from "../../Component/DataGrids/HandsOnTable/BlankTable";
import BlankTableResighting from "../../Component/DataGrids/HandsOnTable/BlankTableResighting";
import useFetch from "../../useHook/useFetch";
import PageDetails from "../../Component/PageDetails";
import { motion, AnimatePresence } from "framer-motion";
import CreatePostFetch from "../../ServerCalls/CreatePostFetch";
import CreateGetFetch from "../../ServerCalls/CreateGetFetch";
import { pageDataLoader } from "../../Api/ReadOnlyFetchData/GetRequests";
import AppContext from "../../Context/AppContext";
import HandsOnTableResighting from "../../Component/DataGrids/HandsOnTable/HandsOnTableResighting";
import { DataBaseValidationResighting } from "../../Utils/Validations/DataBaseValidationResighting";
import { ErrorMerger } from "../../Utils/ErrorMerger";
import CreatePostFetchJSON from "../../ServerCalls/CreatePostFetchJSON";
import ImageModal from "../common/imageModal";
import "./NewQCPage.css";


const NewQCPage = (props) => {
  const params = useParams();
  const { page, year, pType, type, status } = props || params;
  const BASE_URL_LOC = process.env.REACT_APP_SERVER_LOCATION;
  const loadedData11 = useLoaderData();
  const [loadedData, setLoadedData] = useState({ headers: [], errorList: [] })
  const [imageUrl, setImageUrl] = useState("");
  const [backImg, setBackImg] = useState("");
  const [TableData, setTableData] = useState({ headers: [], errorList: [] });
  const [isTableCollapsed, setIsTableCollapsed] = useState(true);
  const appStates = useContext(AppContext);
  const userRole = appStates.getAuthStat();
  const [pageload, setPageLoad] = useState(false);
  const [[conflictPop, conflictsData], setConflictsPop] = useState([false, []]);
  const [pageStatus, setPageStatus] = useState(status);
  const [buttonLoading, setButtonLoading] = useState(null);
  const [imageModal,setImageModal] = useState(false);

  const isAdmin = userRole === "Admin";
  const isResearcher = userRole === "Researcher";
  const isMerged = pageStatus === "Merged";
  const canMerge = pageStatus === "QC_Done";
  const canUnmerge = pageStatus === "Merged";
  const canRemerge = pageStatus === "Merged";

  const tableRef = useRef(null);
  const deletedRows = useRef([]);
  const updatedRows = useRef([]);
  
  useEffect(() => {
    // Clear any invalid entries (non-objects) that might exist
    if (updatedRows.current && updatedRows.current.length > 0) {
      const cleaned = updatedRows.current.filter(
        row => row && typeof row === 'object' && !Array.isArray(row)
      );
      updatedRows.current = cleaned;
    }
  }, []);

  // const handleRowDelete = (rowIndex) => {
  //   const table = tableRef.current?.hotInstance;
  //   if (!table) return;
  //   const dbId = table.getDataAtRowProp(rowIndex, "database_id");
  //   if (dbId) deletedRows.current.push(dbId);
  // };

  const handleRowDelete = (dbId) => {
    if (!deletedRows.current) {
      deletedRows.current = [];
    }
    if (dbId != null && dbId !== -1 && dbId !== 0 && typeof dbId === 'number') {
      if (!deletedRows.current.includes(dbId)) {
        deletedRows.current.push(dbId);
      }
    }
  };
    
    
  const handleRowUpdate = (rowIndex) => {
    const table = tableRef.current?.hotInstance;
    if (!table || rowIndex === undefined || rowIndex === null) return;
    
    try {
      // Get the full row object from the table data
      const headers = table.getColHeader();
      const rowData = table.getDataAtRow(rowIndex);
      
      // Validate that we have valid data
      if (!headers || !Array.isArray(headers) || !rowData || !Array.isArray(rowData)) {
        console.warn("Invalid table data in handleRowUpdate", { headers, rowData });
        return;
      }
      
      // Build row object from headers and row data
      const rowObject = {};
      headers.forEach((header, index) => {
        rowObject[header] = rowData[index];
      });
      
      // Ensure rowObject is a valid object
      if (!rowObject || typeof rowObject !== 'object' || Array.isArray(rowObject)) {
        console.warn("Invalid rowObject created in handleRowUpdate", rowObject);
        return;
      }
      
      const dbId = rowObject.database_id;
      
      // Only add if it has a valid database_id and not already in the list
      if (dbId !== undefined && dbId !== null && dbId !== -1) {
        // Check if this row is already in updatedRows by database_id
        const alreadyExists = updatedRows.current.some(
          row => row && typeof row === 'object' && row.database_id === dbId
        );
        
        if (!alreadyExists) {
          updatedRows.current.push(rowObject);
        } else {
          // Update the existing row with latest data
          const index = updatedRows.current.findIndex(
            row => row && typeof row === 'object' && row.database_id === dbId
          );
          if (index !== -1) {
            updatedRows.current[index] = rowObject;
          }
        }
      }
    } catch (error) {
      console.error("Error in handleRowUpdate:", error);
    }
  };

  async function loadData() {
    const loadedData = await pageDataLoader({ params: { page, year, type } });
    return loadedData;
  }

  useEffect(() => {

    const fetchData = async () => {
      try {
        const loadedData = await loadData();
        setLoadedData(loadedData);
        setImageUrl(loadedData.img);
        setBackImg(loadedData.back_url);

        setTableData((prev => ({ ...prev, ...loadedData })));
        // Clear tracking arrays when new data is loaded
        updatedRows.current = [];
        deletedRows.current = [];
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, [])

  const postBuilder = CreatePostFetch();
  const postBuilderJSON = CreatePostFetchJSON();
  const getBuilder = CreateGetFetch();
  const navigate = useNavigate();
  const [PageType, SetPageType] = useState(pType)



  useEffect(() => {
    const checkIfOccupied = async () => {
      try {
        const response = await fetch(
          `${BASE_URL_LOC}/occupyPage?fileName=${page}&fileYear=${year}`,
          {
            method: "GET",
            redirect: "follow",
            headers: {
              "authentication-token": localStorage.getItem("token"),
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "authentication-token",
              "Access-Control-Expose-Headers": "authentication-token",
            },
            mode: "cors",
          }
        );

        if (response.ok) {
          const result = await response.json();
          if (result.occupied) {
            alert(`This page is already occupied by another ${result.role}.`);
          }
        } else {
          console.error("Failed to fetch occupation status.");
        }
      } catch (error) {
        console.error("Error while fetching occupation status:", error);
      }
    };

    checkIfOccupied();
  }, []);

  const pageLeaveCleanUp = async () => {
    await fetch(`${BASE_URL_LOC}/pageLeave?fileName=${page}&fileYear=${year}`, {
      method: "GET",
      redirect: "follow",
      headers: {
        "authentication-token": localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "authentication-token",
        "Access-Control-Expose-Headers": "authentication-token",
      },
      mode: "cors",
    });
  };

  const { data, loading } = useFetch(
    "/getPageTypeDetails?year=" + year + "&page=" + page
  );

  // this code is for saving the table data
  const [datatable, setDataTable] = useState([]);

  // Function to handle saving data
  const saveData = async (saveType, toValidate) => {
    if (tableRef.current) {
      const headers = tableRef.current.hotInstance.getColHeader(); // Get all column headers
      const tableData = tableRef.current.hotInstance.getData(); // Get table data as an array of arrays
      const tableApi = tableRef.current.hotInstance;
      const structuredData = tableData.map((row) => {
        // Create an object with all headers and their corresponding values
        const rowData = {};
        headers.forEach((header, index) => {
          rowData[header] =
            row[index] !== undefined && row[index] !== null ? row[index] : ""; // Set empty string for missing values
        });
        return rowData;
      });

      // Validate all fields first - if validation fails, return early without API call
      // Only run validation if toValidate is true (for Submit button)
      if (toValidate) {
        const { mergeAllow, errorMessages } = DataBaseValidationResighting(
          tableApi,
          structuredData,
          setSnackBar
        );

        if (!mergeAllow) {
          const MAX_ERRORS = 5;
          const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
          const remainingCount = errorMessages.length - MAX_ERRORS;

          const message =
            limitedErrors.join("\n") +
            (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

          setSnackBar([true, message, "error"]);
          return;
        }
      }

      let formData = new FormData();
      formData.append("data", JSON.stringify(structuredData));
      formData.append("headers", JSON.stringify(headers)); // Ensure headers are sent in JSON format
      formData.append("fileName", loadedData.fileName);
      formData.append("fileYear", loadedData.fileYear);
      formData.append("saveType", saveType);
      formData.append("errorObj", JSON.stringify(TableData.errorList) || false);
      formData.append("pageType", pageType);
      formData.append("pageName", page);
      formData.append("pageYear", year);
      formData.append("resightingInfo", additionInfo.resightingInfo);
      formData.append("otherText", additionInfo.othertext);
      formData.append("problemText", ringingData);

      try {
        let response = await postBuilder.caller("/saveFile", formData);
        if (response.status === 200) {
          setSnackBar([true, "File Saved", "success"]);

          if (saveType) {
            setTimeout(() => {
              navigate("/home");
            }, 1000);
          }
        } else {
          setSnackBar([false, "File Not Submitted", "error"]);
        }
      } catch (error) {
        console.error("Error while saving file:", error);
        setSnackBar([false, "File Not Submitted", "error"]);
      }

    }
  };


  // Function to handle the table data change
  const handleTableDataChange = (newData) => {
    setDataTable(newData);
  };

  //  this is the code for the page type and ringing page fotter dialog box

  const [detailsToggle, setdetailsToggle] = useState(
    localStorage.getItem("userPref_details")
      ? JSON.parse(localStorage.getItem("userPref_details"))
      : false
  );
  const pageDetailsRef = useRef(null);
  const [additionInfo, setAdditionInfo] = useState({
    resightingInfo: false,
    othertext: "",
  });

  const [ringingData, setRingingData] = useState("");
  const handleringingdata = (newringingdata) => {
    setRingingData(newringingdata);
  };
  const [pageType, setPageType] = useState("resighting_page");

  useEffect(() => {
    if (typeof data !== "undefined") {
      setPageType(data.pageType ? data.pageType : "resighting_page");
      setRingingData(data.problemText ? data.problemText : "");
      setAdditionInfo({
        resightingInfo:
          typeof data.resightingInfo !== "undefined" &&
            data.resightingInfo !== null &&
            data.resightingInfo !== 0
            ? data.resightingInfo
            : "",
        othertext: data.otherText ? data.otherText : "",
      });
    }
  }, [data, loading]);
  const handlePageTypeChange = (newPageType) => {
    setPageType(newPageType);
  };

  const handleAdditionalInfoChange = (newInfo) => {
    setAdditionInfo(newInfo);
  };
  const [[snackBarVal, snackBarMsg, snackBarType], setSnackBar] = useState([
    false,
    "File Saved",
    "info",
  ]);

  const handleMerge = async () => {
    setPageLoad(true);
    setButtonLoading("merge");

    try {
      if (!tableRef?.current) return;
      const tableApi = tableRef.current.hotInstance;

      const data = TableData.updated_data;
      const headers = TableData.updated_headers;

      const { mergeAllow, warnUser, errorMessages } = DataBaseValidationResighting(tableApi, data, setSnackBar);

      if (!mergeAllow) {
        const MAX_ERRORS = 5;

        const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
        const remainingCount = errorMessages.length - MAX_ERRORS;

        const message =
          limitedErrors.join("\n") +
          (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

        setSnackBar([true, message, "error"]);
        return;
      };

      // payload
      const payload = {
        data: data,
        headers: headers,
        fileName: page,
        fileYear: year,
        pageType: "resighting_page"
      };

      // confirmation
      if (warnUser) {
        const proceed = window.confirm(
          "The page contains errors. Do you still wish to merge?"
        );
        if (!proceed) return;
      } else {
        const confirmMerge = window.confirm(
          "Are you sure you want to merge this file?");
        if (!confirmMerge) return;
      }

      // API call
      const response = await postBuilderJSON.caller(
        "/getFinalMergedResightingData",
        payload);


      // handling response
      if (response.status === 200 || response.status === 400) {
        const resData = await response.json();

        setTableData(prev => ({
          ...prev,
          updated_data: resData.data,
          updated_headers: resData.headers,
          errorList: ErrorMerger(prev.errorList, resData.errorList),
        }));

        if (response.status === 200) {
          setSnackBar([true, "File has been Merged", "success"]);
          setPageStatus("Merged");
        } else {
          setSnackBar([
            true,
            "Merged Falied. Please review errors.",
            "error",
          ]);
        }

        // Show conflict popup if backend sent mergeErrors
        if (resData.mergeErrors?.length) {
          setConflictsPop([true, resData.mergeErrors]);
        }
      }
      // Any other status
      else {
        const errorText = await response.text();
        setSnackBar([true, `Merge Failed : ${errorText}`, "error"]);
      }
    } catch (err) {
      console.error("Resighting Merge Error", err);
      setSnackBar([true, "Merge failed due to server error", "error"]);
    } finally {
      setPageLoad(false);
      setButtonLoading(null);
    }
  };

  const handleUnmerge = async () => {
    setPageLoad(true);
    let assignmentCount = 0;
    let checkSucceeded = false;
    try {
      const params = new URLSearchParams({
        file_name: page,
        file_year: String(year),
      });
      const checkRes = await getBuilder.caller(
        `/api/resighting/check-resighting-assignments?${params.toString()}`
      );
      if (checkRes.status === 200) {
        const checkBody = await checkRes.json();
        const count = checkBody?.data?.assignment_count;
        if (typeof count === "number") {
          assignmentCount = count;
          checkSucceeded = true;
        }
      }
    } catch (e) {
      console.error("Check resighting assignments before unmerge", e);
    } finally {
      setPageLoad(false);
    }

    const defaultConfirm =
      "Are you sure you want to unmerge this file?";
    const confirmMessage =
      checkSucceeded && assignmentCount > 0
        ? `There ${assignmentCount === 1 ? "is" : "are"} ${assignmentCount} resighting record${
            assignmentCount === 1 ? "" : "s"
          } with active QC assignments linked to this file. Unmerging may affect those assignments.\n\n${defaultConfirm}`
        : defaultConfirm;

    const confirmUnmerge = window.confirm(confirmMessage);
    if (!confirmUnmerge) return;

    setPageLoad(true);
    setButtonLoading("unmerge");

    try {
      // payload
      const payload = {
        fileName: page,
        fileYear: year
      };


      // API call
      const response = await postBuilderJSON.caller(
        "/unmergeResightingRecords",
        payload
      );

      // handle response
      if (response.status === 200 || response.status === 400) {
        const resData = await response.json();

        if (response.status === 200) {
          setSnackBar([true, resData?.message, "success"]);

          // Optional: refresh table data if backend sends updated data
          if (resData.data && resData.headers) {
            setTableData(prev => ({
              ...prev,
              updated_data: resData.data,
              updated_headers: resData.headers,
              errorList: resData.errorList ?? [],
            }));
          }
          setPageStatus("QC_Done");
        } else {
          setSnackBar([
            true,
            resData?.message || resData?.error || "Unmerge failed. Please review errors.",
            "error",
          ]);
        }
      }
      // unexpected status
      else {
        const errorText = await response.text();
        setSnackBar([true, `Unmerge Failed : ${errorText}`, "error"]);
      }
    } catch (err) {
      console.error("Resighting Unmerge Error", err);
      setSnackBar([true, "Unmerge failed due to server error", "error"]);
    } finally {
      setPageLoad(false);
      setButtonLoading(null);
    }
  };

  const handleRevertCall = async () => {
    let performAction = window.confirm(
      "Do you wish to Revert file status back to 'QC_Done' ?"
    );
    if (performAction) {
      const formBody = new FormData();
      formBody.append("fileName", page);
      formBody.append("fileYear", year);
      const res = await postBuilder.caller("/revertQcDone", formBody);
      if (res.status === 200) {
        setSnackBar([true, "File Reverted. Kindly Exit the Page", "success"]);
      } else {
        setSnackBar([true, "Revert Failed", "error"]);
      }
    }
  };

  const handleRemerge = async () => {
    setPageLoad(true);
    setButtonLoading("remerge");

    try {
      if (!tableRef?.current) return;

      const tableApi = tableRef.current.hotInstance;
      const data = TableData.updated_data;
      const headers = TableData.updated_headers;

      // DATABASE VALIDATION (MANDATORY)
      const { mergeAllow, warnUser, errorMessages } =
        DataBaseValidationResighting(tableApi, data, setSnackBar);

      if (!mergeAllow) {
        const MAX_ERRORS = 5;
        const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
        const remainingCount = errorMessages.length - MAX_ERRORS;

        const message =
          limitedErrors.join("\n") +
          (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

        setSnackBar([true, message, "error"]);
        return;
      }

      // CONFIRMATION
      const confirmRemerge = window.confirm(
        warnUser
          ? "The page contains warnings. Do you still want to remerge?"
          : "Are you sure you want to remerge this file?"
      );
      if (!confirmRemerge) return;

      const fullData = TableData.updated_data || [];

      const insertedList = fullData.filter(
        r => r.database_id === -1 || r.database_id === null
      );

      // const data = fullData.filter(
      //   r => r.database_id !== -1 && r.database_id !== null
      // );

      // PAYLOAD
      const rawUpdatedRows = Array.isArray(updatedRows.current) ? updatedRows.current : [];
      
      const validUpdatedRows = rawUpdatedRows
        .filter(row => {
          // Must be an object (not a primitive like integer, string, etc.)
          if (!row || typeof row !== 'object' || Array.isArray(row)) {
            console.warn("Filtered out non-object from updatedRows:", row, typeof row);
            return false;
          }
          // Must have a valid database_id (not -1, null, or undefined)
          const dbId = row.database_id;
          if (dbId === undefined || dbId === null || dbId === -1) {
            console.warn("Filtered out row with invalid database_id:", dbId);
            return false;
          }
          return true;
        })
        // Remove duplicates based on database_id
        .filter((row, index, self) =>
          index === self.findIndex(r => r.database_id === row.database_id)
        );
      
      // Final validation: ensure updatedList is an array of objects
      // Note: validUpdatedRows is already filtered, but we validate the type for safety
      const finalUpdatedList = Array.isArray(validUpdatedRows) ? validUpdatedRows : [];
      
      const payload = {
        data: data,
        headers: headers,
        updatedList: finalUpdatedList,
        deletedList: [...new Set(deletedRows.current)],
        insertedList: insertedList,
        pageType: "resighting_page",
        fileName: page,
        fileYear: year,
      };

      // console.log("REMERGE PAYLOAD", payload);
      // console.log("UPDATED LIST DETAILS:", {
      //   raw: updatedRows.current,
      //   rawLength: rawUpdatedRows.length,
      //   filtered: finalUpdatedList,
      //   count: finalUpdatedList.length,
      //   sample: finalUpdatedList.slice(0, 2)
      // });

      // API CALL
      const response = await postBuilderJSON.caller(
        "/remergeResightingRecords",
        payload
      );

      if (response.status === 200 || response.status === 400) {
        const resData = await response.json();

        if (response.status === 200) {
          setSnackBar([true, "File has been remerged successfully", "success"]);

          // Update table if backend returns data
          if (resData.data && resData.headers) {
            setTableData(prev => ({
              ...prev,
              updated_data: resData.data,
              updated_headers: resData.headers,
              errorList: resData.errorList ?? [],
            }));
            updatedRows.current = [];
            deletedRows.current = [];
          }

          // STATUS STAYS MERGED
          setPageStatus("Merged");
        } else {
          setSnackBar([
            true,
            resData?.message || "Remerge failed. Please review errors.",
            "error",
          ]);
        }
      } else {
        const errorText = await response.text();
        setSnackBar([true, `Remerge Failed : ${errorText}`, "error"]);
      }
    } catch (err) {
      console.error("Resighting Remerge Error", err);
      setSnackBar([true, "Remerge failed due to server error", "error"]);
    } finally {
      setPageLoad(false);
      setButtonLoading(null);
    }
  };



  // this is the code for dialogbox 


  return (
    <div>
      <PageLeaveWrapper cleanUpCall={pageLeaveCleanUp}>
        <Grid container justifyContent="center" spacing={2}>
          {/* Left Section */}
          <Grid
            item
            xs={12}
            md={6}
            lg={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: { xs: "auto", md: "100vh" },
              marginTop: { xs: "1rem", md: 0, xl: "1.5rem" },
            }}
          >
            <div className="img-wrapper" onDoubleClick={() => setImageModal(true)}>
              <ImageViewer imageUrl={imageUrl} backImg={backImg} />
            </div>
          </Grid>

          {
            imageModal && (
              <ImageModal 
                imageUrl={imageUrl} 
                backImg={backImg} 
                onClose={() => setImageModal(false)} 
              />
            )
          }

          {/* Right Section */}
          <Grid
            item
            xs={12}
            md={6}
            lg={7}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              // height: "100vh",
              minHeight: 0,
            }}
          >
            <div className="table-container">

              {/* Collapse/Expand Button */}
              <div className="collapse-control">
                <button
                  onClick={() => setIsTableCollapsed(!isTableCollapsed)}
                  className="collapse-btn"
                >
                  {isTableCollapsed ? '▼ Expand Table' : '▲ Collapse Table'}
                </button>
              </div>

              {/* Conditionally render content based on collapse state */}

              {!isTableCollapsed && (
                <>
                  {!TableData?.headers ? (
                    <div className="bg-white p-4">
                      {TableData?.data && TableData?.data?.length > 0 ? (
                        TableData?.data?.map((item, index) => (
                          <p key={index}>{item.text}</p>
                        ))
                      ) : (
                        <p>No data available</p>
                      )}
                    </div>
                  ) : (
                    <div className="table-container3">
                      <table className="custom-table">
                        <thead >
                          <tr>
                            {TableData?.data?.[0] && Object.keys(TableData?.data?.[0])?.map((key, index) => (
                              <th key={index}>{key}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {TableData?.data?.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {Object.values(row).map((value, colIndex) => (
                                <td key={colIndex}>{value}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}

            </div>

            {/* <div className="table-container-2">
              {pageType === "resighting_page" ? <BlankTableResighting
                ref={tableRef}
                onDataChange={handleTableDataChange}
                TableData={TableData}
              /> : <BlankTable
                ref={tableRef}
                onDataChange={handleTableDataChange}
                TableData={TableData}
              />
              }

            </div> */}
            <div className="table-container-2">
              {/* {pageType === "resighting_page" ? <HandsOnTableResighting */}
              {["resighting_page", "back_page"].includes(pageType) ? <HandsOnTableResighting
                ref={tableRef}
                // onDataChange={handleTableDataChange}
                delRowsCallback={handleRowDelete}
                updatedRowsCallBack={handleRowUpdate}
                TableData={TableData}
              /> : <BlankTable
                ref={tableRef}
                onDataChange={handleTableDataChange}
                TableData={TableData}
              />
              }

            </div>
          </Grid>

          <Grid item sm={12} md={12} lg={12}>
            <div className="details_subsection">
              <AnimatePresence mode="wait">
                {detailsToggle && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1 }}
                    key={"subsection_details_toggle"}
                    className="toggle_subsection"
                  >
                    <Switch
                      checked={!detailsToggle}
                      onChange={() => {
                        setdetailsToggle(!detailsToggle);
                      }}
                    />
                    Show Page Tagging Panel
                  </motion.div>
                )}

                <motion.div
                  initial={{ height: 0 }}
                  animate={{ height: "auto" }}
                  exit={{ height: 0 }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  key={"subsection_detailsPannel"}
                >
                  <PageDetails
                    ref={pageDetailsRef}
                    toggleController={setdetailsToggle}
                    year={year}
                    page={page}
                    setSnackBar={setSnackBar}
                    showOptions={false}
                    pageType={pageType}
                    additionInfo={additionInfo}
                    ringingData={ringingData}
                    setPageType={handlePageTypeChange}
                    setAdditionInfo={handleAdditionalInfoChange}
                    setRingingData={handleringingdata}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          </Grid>
          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            display={"flex"}
            justifyContent={"center"}
            gap={"1rem"}
            alignItems={"center"}
            marginTop={"1rem"}
            marginBottom={"1rem"}
          >

            {isAdmin && canMerge && (
              <>
                {/* Revert */}
                <Button
                  onClick={handleRevertCall}
                  variant="contained"
                  color="secondary"
                >
                  Revert
                </Button>
              </>
            )}  

            <Button onClick={() => {
              saveData(false, false);
            }} variant="contained" color="success">
              Save
            </Button>

            <Button
              onClick={() => {
                if (
                  window.confirm(
                    "Are you sure you want to Submit the file? Once submitted changes cannot be made to the file."
                  )
                ) {
                  saveData(true, true);
                }
              }}
              variant="contained"
              color="success"
            >
              Submit
            </Button>

            {/* ADMIN + RESEARCHER ACTIONS */}
            {(isAdmin || isResearcher) && (
              <>
                {/* Merge */}
                <span
                  title={isMerged ? "File is already merged" : !canMerge ? "File must be QC Done before merge" : ""}>
                  <Button
                    onClick={handleMerge}
                    variant="contained"
                    color="primary"
                    disabled={isMerged || !canMerge || buttonLoading === "merge"}
                  >
                    {buttonLoading === "merge" ? "Merging..." : "Merge"}
                  </Button>
                </span>
              </>
            )}

            {/* ADMIN ONLY ACTIONS */}            
              {isAdmin && (
                <>
                  {/* Unmerge */}
                  <span title={!canUnmerge ? "File is not yet merged, so can't unmerge" : ""}>
                    <Button
                      onClick={handleUnmerge}
                      variant="contained"
                      color="warning"
                      disabled={!canUnmerge || buttonLoading === "unmerge"}
                    >
                      {buttonLoading === "unmerge" ? "Unmerging..." : "Unmerge"}
                    </Button>
                  </span>
                </>
              )}  

              {(isAdmin || isResearcher) && (
                // Remerge 
                <>
                  <span title={!canRemerge ? "File must be merged before remerge" : "Re-merge with updated data"}>
                    <Button
                      onClick={handleRemerge}
                      variant="contained"
                      color="secondary"
                      disabled={!canRemerge || buttonLoading === "remerge"}
                    >
                      {buttonLoading === "remerge" ? "Remerging..." : "Remerge"}
                    </Button>
                  </span>
                </>
              )}
          </Grid>

          {/* {pageload && <LoadingWrapper />} */}

          <Snackbar
            open={snackBarVal}
            key={"SnackBar"}
            autoHideDuration={null}
            onClose={() => {
              setSnackBar((prevState) => [false, prevState[1], prevState[2]]);
            }}
          >
            <Alert
              onClose={() => setSnackBar([false, snackBarMsg, snackBarType])}
              severity={snackBarType}
              variant="filled"
              sx={{
                width: "100%",
                whiteSpace: "pre-line",
              }}
            >
              {snackBarMsg}
            </Alert>
          </Snackbar>
          {/* 
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={conflictPop}
          onClose={handleCloseDialog}
        >
          <ConflictDisplay conflictsData={conflictsData} />
        </Dialog> */}
        </Grid>
      </PageLeaveWrapper>
    </div>
    // <p>Hello World</p>
  );
};

export default NewQCPage;
